
 <template lang="">
 <FullScreenLayout>
      <template #page-content="props">
        <h1 style="color:#cf1818" class=" text-center">{{dateDesc}}</h1>
        <!-- <v-card id="event-viewerCard"
                        class="form-card" 
                        outlined 
                        > -->
        <EventsViewer
        :max-item-x-page="UISettings.dayEventViewer.maxItemPerPage" 
          :slideSeconds="dayEventViewerSecondsSpeed"
          :date="date"
        ></EventsViewer>
        <!-- </v-card> -->
     </template>
 </FullScreenLayout> 
</template>
<style lang="">
/* .form-card.v-card.v-sheet.v-sheet--outlined.theme--light {
  background: transparent;
  border: 0px;
} */
</style> 
<script>
import EventsViewer from "../components/EventsViewer/EventsViewer";
import FullScreenLayout from "../layout/FullScreenLayout";
import moment, { months } from "moment";
import router from "../router/index";
const monthNames = [
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "November",
  "December",
];

import UISettingsHelper from "../utils/UISettingsHelper";
export default {
  components: {
    EventsViewer,
    FullScreenLayout,
    moment,
  },
  async created(){
  UISettingsHelper.Configure(this.$route.params.companyAlias); 
  },
  mounted() {
    this.creationDate = new Date(
      Date.parse(moment(new Date()).format("MM/DD/YYYY"))
    );
    let t = this;
    setInterval(this.checkIfHaveToChangeDay, 1000);
  },
  methods: {
    checkIfHaveToChangeDay() {
      let t = this;
      console.debug("check if i've to add day");
      let curDate = new Date(
        Date.parse(moment(new Date()).format("MM/DD/YYYY"))
      );
      let diff = curDate.getTime() - t.creationDate.getTime();
      let daysDec = diff / (1000 * 3600 * 24);
      console.debug("daysDec", daysDec);
      let days = Math.floor(daysDec);
      console.debug("days", days);
      if (days > 0) {
        let date = new Date(Date.parse(this.$route.query.date));
        let nextDate = this.addDays(date, 1);
        this.creationDate = new Date(
          Date.parse(moment(new Date()).format("MM/DD/YYYY"))
        );
        console.debug("go to next", nextDate);
        router.push({
          name: "event-viewer",
          query: { date: moment(nextDate).format("MM/DD/YYYY") },
        });
      }
      // this.$route.query.date = moment(this.addDays(date, days)).format(
      //   "MM/DD/YYYY"
      // );
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
  },
  data() {
    return {
      moment: moment,
      creationDate: new Date(),
      monthNames: monthNames,
    };
  },
  computed: {
    
    dayEventViewerSecondsSpeed() {
      // let num = 10 / UISettings.dayEventViewer.scrollerSpeed;
      return 10 - this.UISettings.dayEventViewer.scrollerSpeed + 1; // Math.round(num * 100) / 100
    },
    UISettings() {
      UISettingsHelper.LoadSettings();
      return UISettingsHelper.GetSettings();
    },
    date() {
      let date = Date.parse(this.$route.query.date);
      console.debug("this.$route.query.date", this.$route.query.date);
      console.debug("DATE", date);
      return date;
    },
    dateDesc() {
      let day = moment(this.date).format("DD");
      let m = moment(this.date).format("M");
      let month = this.monthNames[Number(m) - 1];
      let year = moment(this.date).format("YYYY");
      console.debug("day", day);
      console.debug("month", month);
      console.debug("year", year);
      return day + " " + month + " " + year;
    },
  },
};
</script>